module.exports = __webpack_public_path__ + "static/media/e4e50ec1-6807-4194-8d08-9a535943a156.1937a5db.JPG";